import { useShowCampaignById_new } from '@givebacks/api/store';

import { useCrowdfundingProvider } from '../../../../Context';
import { CampaignStoreItemTypes } from '../../types/utils';

// TODO: Deprecate this and replace with just useCrowdfundingProvider
const useCampaignInfoByProvider = () => {
  const { causeId, campaignId } = useCrowdfundingProvider();

  return {
    causeId,
    campaignId,
  };
};

/**
 * @deprecated use createCampaignSettings from @givebacks/api/store instead
 */
const createCampaignSettings = (data?: CampaignStoreItemTypes) => {
  return {
    isTeamsEnabled: data?.team_options?.enabled,
    isParticipantsEnabled: data?.participant_options?.enabled,
    isRegistrationOpen: data?.participant_options?.registration_open,
    isRegistrationByAdminOnly: data?.participant_options?.registration_by === 'admin_only',
    isParticipantsInCenterEnabled: data?.participant_options?.show_in_center,
    isTeamsInCenterEnabled: data?.team_options?.show_in_center,
    isLeaderboardInCenterEnabled: data?.participant_options?.show_on_leaderboard,
    isPeersDisabled: !data?.team_options?.enabled && !data?.participant_options?.enabled,
    isPeersEnabled: data?.team_options?.enabled || data?.participant_options?.enabled,
    isTeamPrizesEnabled: data?.team_options?.prizes_enabled,
    isParticipantPrizesEnabled: data?.participant_options?.prizes_enabled,
    isCampaignPublished: data?.status === 'published',
    isCampaignDraft: data?.status === 'draft',
    isCampaignFinished: data?.status === 'finished',
    isBenefitsEnabled: data?.benefit_options?.enabled,
    isCampaignDeleted: !!data?.deleted_at,
    type: data?.__type,
  };
};

/**
 * Provides a singular structured response to formulate highly used evaluations
 * @deprecated use useShowCampaignSettings from @givebacks/api/store instead
 */
const useShowCampaignSettings = () => {
  const { campaignId, causeId } = useCampaignInfoByProvider();
  const { data, isLoading, isSuccess, isFetching } = useShowCampaignById_new({
    campaignId,
    causeId,
  });

  const campaignSettings = createCampaignSettings(data);

  // By checking if the query is even enabled, we can have another layer of checking and not strictly rely on isLoading
  const isQueryEnabled = campaignId && causeId;

  return {
    data: campaignSettings,
    isLoading,
    isEnabled: isQueryEnabled,
    isSuccess,
    isFetching,
  };
};

export { useCampaignInfoByProvider, useShowCampaignSettings };
